/**
 * News Module
 * This is the main behavior file for News single pages and text-heavy pages (wall of text)
 * Handles:
 * - Table of contents generation from H2 and H3 headings
 * - H2 headings with H3 children are collapsible/expandable
 * - Sticky table of contents positioning while scrolling
 * - Smooth scrolling to sections when clicking table of content links
 * - Only applies these behaviors for tablet/desktop viewports (>= 820px)
 */

export default class News {
  /* ===================================
   *  CONSTRUCTOR
   * =================================== */
  constructor() {
    this.bindEvents();
  }

  /* ===================================
   *  EVENTS
   * =================================== */
  bindEvents() {
    // Put Page Content into tablet of content
    this.ContentPageSetup();
  }

  ContentPageSetup() {
    // Generate table of contents from h2 and h3 headings
    if ($(".table-of-content").length && $(".content-holder").length) {
      const $tableOfContent = $(".table-of-content .headline-list");
      const $contentHolder = $(".content-holder");
      const $contentHeadings = $contentHolder.find("h2, h3");
      const $tableOfContentWidget = $(".table-of-content-widget");

      // Clear existing items
      $tableOfContent.empty();

      // Check if there are any headings
      if ($contentHeadings.length === 0) {
        // Hide table of content widget if no headings found
        $tableOfContentWidget.hide();

        // Add span-2-col class to main-col within news-content-holder
        $(".news-content-holder .main-col").addClass("span-2-col");
        return;
      }

      // Show table of content widget if headings exist
      $tableOfContentWidget.show();

      // Remove span-2-col class from main-col (to handle reload scenarios)
      $(".news-content-holder .main-col").removeClass("span-2-col");

      // Group headings: find h2 and their child h3 elements
      const headingGroups = [];
      let currentH2 = null;

      $contentHeadings.each(function () {
        const $heading = $(this);
        const tagName = $heading.prop("tagName").toLowerCase();

        if (tagName === "h2") {
          // Start a new h2 group
          currentH2 = {
            h2: $heading,
            h3s: [],
          };
          headingGroups.push(currentH2);
        } else if (tagName === "h3" && currentH2) {
          // Add h3 to current h2 group
          currentH2.h3s.push($heading);
        }
      });

      // Generate TOC items
      headingGroups.forEach((group, groupIndex) => {
        const $h2 = group.h2;
        const h2Text = $h2.text();

        // Generate random ID if heading doesn't have one
        const h2Id =
          $h2.attr("id") ||
          "heading-" + Math.random().toString(36).substr(2, 9);

        // Create anchor span and insert before heading text
        const $h2Anchor = $('<span class="heading-anchor"></span>').attr(
          "id",
          h2Id
        );
        $h2.prepend($h2Anchor);

        // Create h2 TOC item
        const $h2TocItem = $(
          '<li class="headline-item headline-item-h2"></li>'
        );
        const $h2Link = $(`
          <a href="#${h2Id}" class="headline-link">
            <span class="headline-txt">${h2Text}</span>
          </a>
        `);

        // If h2 has h3 children, make it collapsible
        if (group.h3s.length > 0) {
          $h2Link.append('<span class="headline-toggle"></span>');
          $h2TocItem.addClass("has-children");

          // Create nested list for h3 items
          const $h3List = $('<ul class="headline-sublist"></ul>');

          group.h3s.forEach(($h3, h3Index) => {
            const h3Text = $h3.text();
            const h3Id =
              $h3.attr("id") ||
              "heading-" + Math.random().toString(36).substr(2, 9);

            // Create anchor span for h3
            const $h3Anchor = $('<span class="heading-anchor"></span>').attr(
              "id",
              h3Id
            );
            $h3.prepend($h3Anchor);

            // Create h3 TOC item
            const $h3TocItem = $(`
              <li class="headline-item headline-item-h3">
                <a href="#${h3Id}" class="headline-link">
                  <span class="headline-txt">${h3Text}</span>
                </a>
              </li>
            `);

            $h3List.append($h3TocItem);
          });

          $h2TocItem.append($h2Link);
          $h2TocItem.append($h3List);
        } else {
          // No h3 children, just add the link
          $h2TocItem.append($h2Link);
        }

        // Add active class to first item
        if (groupIndex === 0) {
          $h2TocItem.addClass("active");
        }

        $tableOfContent.append($h2TocItem);
      });

      // Handle toggle for collapsible h2 items
      $(document).on(
        "click",
        ".headline-item-h2.has-children .headline-toggle",
        function (e) {
          e.preventDefault();
          e.stopPropagation();
          const $item = $(this).closest(".headline-item-h2");
          $item.toggleClass("expanded");
        }
      );

      // Handle click on TOC links to hide header and quick-access if visible
      let scrollDetectionDisabled = false;
      let clickedHeadingId = null;

      $(document).on("click", ".headline-link", (e) => {
        // Get the target heading ID from the link
        const href = $(e.currentTarget).attr("href");
        if (href && href.startsWith("#")) {
          clickedHeadingId = href.substring(1); // Remove the # symbol

          // Immediately set the clicked item as active
          $(".headline-item").removeClass("active");
          const $clickedItem = $(e.currentTarget).parent(".headline-item");
          $clickedItem.addClass("active");

          // If it's an h3, also expand its parent h2
          if ($clickedItem.hasClass("headline-item-h3")) {
            const $parentH2 = $clickedItem.closest(".headline-item-h2");
            $parentH2.addClass("expanded");
          }

          // Disable scroll detection during smooth scroll
          scrollDetectionDisabled = true;
        }

        // Set flag to prevent showing header/quick-access during TOC scroll
        window.TOC_SCROLLING = true;

        const $header = $("header");
        const $quickAccess = $(".hm-quick-access");
        const $quickAccessBgOverlay = $(".quick-access-bg-overlay");

        // Hide header and quick-access immediately
        if (!$header.hasClass("header-is-hidden")) {
          $header.addClass("header-is-hidden");
        }

        if (!$quickAccess.hasClass("quick-access-is-hidden")) {
          $quickAccess.addClass("quick-access-is-hidden");
          $quickAccessBgOverlay.addClass("quick-access-is-hidden");
        }

        // Re-enable scroll detection after scroll animation completes
        setTimeout(() => {
          window.TOC_SCROLLING = false;
          scrollDetectionDisabled = false;
          clickedHeadingId = null;
        }, 1100);
      });

      // Handle active state of TOC items on scroll
      // Only bind scroll event for screens > 900px
      if (window.innerWidth > 900) {
        let ticking = false;

        const updateActiveHeading = () => {
          // Don't update if scroll detection is disabled (during TOC click scroll)
          if (scrollDetectionDisabled) {
            ticking = false;
            return;
          }

          const scrollPosition = $(window).scrollTop();
          const viewportTop = scrollPosition + 300; // Add header offset
          const viewportBottom = scrollPosition + $(window).height();

          // Get all headings with their positions
          const headings = [];
          $(".content-holder h2, .content-holder h3").each(function () {
            const $heading = $(this);
            const headingPosition = $heading.offset().top;
            const headingId = $heading.find(".heading-anchor").attr("id");

            if (headingId) {
              headings.push({
                id: headingId,
                position: headingPosition,
                element: $heading,
              });
            }
          });

          // Find the heading that's currently in viewport or the last one we passed
          let activeHeadingId = null;
          let activeHeadingPosition = -1;

          // First, check if any heading is in the viewport (with a tolerance)
          for (let i = 0; i < headings.length; i++) {
            const heading = headings[i];
            // Check if heading is within viewport with some tolerance
            if (
              heading.position >= viewportTop - 50 &&
              heading.position <= viewportBottom
            ) {
              activeHeadingId = heading.id;
              activeHeadingPosition = heading.position;
              break;
            }
          }

          // If no heading in viewport, find the last one we've scrolled past
          if (!activeHeadingId) {
            for (let i = headings.length - 1; i >= 0; i--) {
              const heading = headings[i];
              if (heading.position <= viewportTop + 50) {
                activeHeadingId = heading.id;
                activeHeadingPosition = heading.position;
                break;
              }
            }
          }

          // If still no active heading and we're at the top, activate the first one
          if (!activeHeadingId && headings.length > 0 && scrollPosition < 100) {
            activeHeadingId = headings[0].id;
          }

          // Update active state
          if (activeHeadingId) {
            // Remove active class from all items
            $(".headline-item").removeClass("active");

            // Add active class to corresponding TOC item
            const $activeLink = $(
              `.headline-item a[href="#${activeHeadingId}"]`
            );
            const $activeItem = $activeLink.parent(".headline-item");
            $activeItem.addClass("active");

            // If it's an h3, also expand its parent h2
            if ($activeItem.hasClass("headline-item-h3")) {
              const $parentH2 = $activeItem.closest(".headline-item-h2");
              $parentH2.addClass("expanded");
            }
          }

          ticking = false;
        };

        $(window).on("scroll", function () {
          if (!ticking) {
            window.requestAnimationFrame(updateActiveHeading);
            ticking = true;
          }
        });

        // Initial call to set active state on page load
        updateActiveHeading();
      }
    }
  }
}
